import { startVoiceWaveAnimation, stopVoiceWaveAnimation } from "./animations";
import { startConversation, stopConversation } from "./eleven-labs";


let microphoneStream: MediaStream | null = null;

/**
 * Request and cache the user's microphone stream
 */
export async function getMicrophoneStream(): Promise<MediaStream> {
  if (microphoneStream) return microphoneStream;

  try {
    microphoneStream = await navigator.mediaDevices.getUserMedia({ audio: true });
    return microphoneStream;
  } catch (err) {
    console.error('Microphone access denied or failed:', err);
    throw err;
  }
}

/**
 * Stop and clean up the microphone stream
 */
export function stopMicrophoneStream() {
  if (microphoneStream) {
    microphoneStream.getTracks().forEach(track => track.stop());
    microphoneStream = null;
  }
}

/**
 * Start conversation and voice wave animation
 */
export async function startVoiceSession(
  agentId: string,
  statusElement: HTMLParagraphElement,
  wavesRoot: HTMLDivElement,
  wavelets: HTMLDivElement[],
  messagesContainer:HTMLDivElement,
  micButton:HTMLButtonElement
): Promise<void> {
  const stream = await getMicrophoneStream();

  await startConversation( stream,agentId, statusElement,messagesContainer,micButton);
  await startVoiceWaveAnimation(stream, wavesRoot, wavelets);
  wavesRoot.classList.remove('hidden');
}

/**
 * Stop conversation, voice wave animation, and mic stream
 */
export async function stopVoiceSession(
  statusElement: HTMLParagraphElement,
  wavesRoot: HTMLDivElement
): Promise<void> {
  stopVoiceWaveAnimation();
  await stopConversation();
  stopMicrophoneStream();
  statusElement.textContent = 'Ready to listen';
  wavesRoot.classList.add('hidden');
}

